import { HttpErrorResponse } from '@angular/common/http';
import { Action, createReducer, on } from '@ngrx/store';

import { HomeUsesFailure, HomeUsesRequest, HomeUsesSuccess } from './actions';
import { ParameterResult } from '@models/swagger';

export const featureKey = 'homeUses';

export interface State {
  data: ParameterResult[] | null;
  error: HttpErrorResponse | null;
  loading: boolean;
}

export const initialState: State = {
  data: [],
  error: null,
  loading: null,
};

export function reducer(state: State | undefined, action: Action) {
  return createReducer(
    initialState,
    on(HomeUsesFailure, (state, { error }) => ({ ...state, data: [], error, loading: false })),
    on(HomeUsesRequest, state => ({ ...state, error: null, loading: true })),
    on(HomeUsesSuccess, (state, { data }) => ({ ...state, data, error: null, loading: false }))
  )(state, action);
}
